// @flow

import React from 'react'
import { imagePath } from 'frontend_core/dist/helpers/image'
import {
  GoogleTagManagerHead,
  GoogleTagManagerBody,
} from 'components/shared/GoogleTagManager'
import HeaderContainer from 'containers/organisms/HeaderContainer'
import Footer from 'components/shared/footer/Footer'
import 'components/styles'

export default function ErrorTemplate(props) {
  const title = i18n.t(
    `error.${props.status}.title` || 'server.shared.default_title',
  )
  const description = i18n.t(`error.${props.status}.description`) || ''
  const siteName = i18n.t('server.shared.default_site_name')

  function renderRoot() {
    return (
      <div>
        <HeaderContainer {...props} />
        {props.children}
        <Footer {...props} />
      </div>
    )
  }

  function renderAll() {
    return (
      <html lang={i18n.t('locale')}>
        <head>
          <meta charSet="utf-8" />
          <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1, user-scalable=no"
          />
          <title>{`${title} | ${siteName}`}</title>
          <meta name="description" content={description} />
          <link rel="stylesheet" href={manifest['main.css']} media="screen" />
          <link
            rel="stylesheet"
            href="https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css"
          />
          <link rel="dns-prefetch" href="//spacemarket.com" />
          <link
            rel="apple-touch-icon"
            href={imagePath('common/apple-touch-icon.png')}
          />
          <GoogleTagManagerHead />
        </head>
        <body className="site-service">
          <div id="js-root">{renderRoot()}</div>
          <GoogleTagManagerBody />
        </body>
      </html>
    )
  }
  return props.config.SSR ? renderAll() : renderRoot()
}



// WEBPACK FOOTER //
// ./src/components/templates/ErrorTemplate/index.jsx